"use strict";

exports.__esModule = true;
exports.default = createHistoryMiddleware;

var _ActionTypes = _interopRequireDefault(require("./ActionTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function updateLocation(location) {
  return {
    type: _ActionTypes.default.UPDATE_LOCATION,
    payload: location
  };
}

function createHistoryMiddleware(protocol) {
  return function historyMiddleware() {
    return function (next) {
      var dispose = protocol.subscribe(function (location) {
        next(updateLocation(location));
      });
      return function (action) {
        var type = action.type,
            payload = action.payload;

        switch (type) {
          case _ActionTypes.default.INIT:
            return next(updateLocation(protocol.init()));

          case _ActionTypes.default.TRANSITION:
            return next(updateLocation(protocol.transition(payload)));

          case _ActionTypes.default.GO:
            protocol.go(payload);
            return null;

          case _ActionTypes.default.CREATE_HREF:
            return protocol.createHref(payload);

          case _ActionTypes.default.CREATE_LOCATION:
            return payload;

          case _ActionTypes.default.DISPOSE:
            dispose();
            return null;

          default:
            return next(action);
        }
      };
    };
  };
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/found/node_modules/farce/lib/createHistoryMiddleware.js
// module id = 1222
// module chunks = 0